module.exports = __webpack_public_path__ + "static/media/6845.08e75d41.jpg";